import React from "react"
import { graphql, Link } from "gatsby"
// temp
import "../pages/index.css";

import Tags from '../components/tags';
import Social from '../components/social';

import SEO from "../components/seo";

import Layout from "../components/layout";
import { FacebookShareButton, FacebookIcon } from 'react-share';
import Helmet from 'react-helmet'
import DateFormatter from '../components/date-formatter'

export default ({data}) => {

    var post = data.article.edges[0].node;
    var tags = post.frontmatter.tags;
  return (
    <Layout selected='/none'>
    <SEO title={post.frontmatter.title} description={post.html.replace(/<(?:.|\n)*?>/gm, '').substring(0,400)} keywords={[ ...tags.map((elem) => (elem.frontmatter.label))]} />
    <Helmet
          >
          <meta property="og:url"                content={'http://www.crearemondi.it/post/'+post.frontmatter.slug} />
          <meta property="og:type"               content="article" />
          <meta property="og:title"              content={post.frontmatter.title} />
          <meta property="og:description"        content={post.html.replace(/<(?:.|\n)*?>/gm, '').substring(0,400)} />
          <meta property="og:image"              content={"http://www.crearemondi.it/" + ((post.frontmatter.banner === null || post.frontmatter.banner === '') ? post.frontmatter.thumbnail : post.frontmatter.banner)} />
    </Helmet>
    <div className="aboutContainer">
      <div className="content">
      <br/>
      { post.frontmatter.banner && <div
      className="postBanner"
      style={{
        backgroundImage: `url(${post.frontmatter.banner})`,
        backgroundRepeat: "no-repeat",
        backgroundPosition: 'center',
        width: '100%',
        backgroundSize: 'cover'
      }}
     ></div>}
      
      
    <h4
    className="dateAuthor"
    style={{
      lineHeight: '24px',
      marginBottom: '14px',
    }}
    ><DateFormatter date={post.frontmatter.date}/> - {post.frontmatter.author}</h4>
    <div>
      <div className="articleTitle" style={{
      }}>
      <h2 style={{
      }}>{post.frontmatter.title}</h2>
      </div>
     
      <div style={{
        textAlign: 'justify'
      }} className="articleBody" dangerouslySetInnerHTML={{__html: post.html}}>
     </div>
     <div className="shareArticle">
     <FacebookShareButton style={{cursor: 'pointer', width: 150}} url={'http://www.crearemondi.it/post/'+post.frontmatter.slug}>
      <div style={{display: 'flex'}}><FacebookIcon round={true} size={40}/> <div className='shareText'>&nbsp;&nbsp;Condividi</div></div>
     </FacebookShareButton>
     </div>
     <br/>
     <div className="articleTags">
       <b>TAG </b>
       <>{tags.map((elem, id) => {
                                return (<><span
                                    key={id}
                                    style={{
                                    textTransform: 'uppercase',
                                    textDecoration: 'underline',
                                    cursor: 'pointer',
                                    whiteSpace: 'nowrap'
                                }}><Link to={'/tag/' + elem.frontmatter.name} style={{textDecoration: 'none', color: 'hsla(0, 0%, 0%, 0.8)'}}>{ elem.frontmatter.label }</Link></span> </>)})
                              
                              }</>
     </div>
     

    
 



    </div>
      </div>
      <div className="sidebar">
      <br/>
      <div className="altri">
        <h4 className="title">
          ALTRE STORIE
        </h4>
        <div className="altriBox">
          {
            data.others.edges.filter((obj, id) => {
              if (obj.node.frontmatter.title === post.frontmatter.title) {
                return false;
              } else {
                return true;
              }
            }).slice(0, 3).map((object, id) => {
              return <Link className="otherStory" to={'/post/'+object.node.frontmatter.slug} style={{textDecoration: 'none', color: 'hsla(0, 0%, 0%, 0.8)'}}>
              <div
              className="image"
              style={{
                backgroundImage: `url(${object.node.frontmatter.thumbnail})`,
                backgroundRepeat: "no-repeat",
                backgroundPosition: 'center',
                backgroundSize: 'cover',
                width: '100%'
              }}
            >
            </div>
            <div className="articlePrevAuthor" style={{
              paddingTop: '5px'
            }}>
                <DateFormatter date={object.node.frontmatter.date} /> - {object.node.frontmatter.author}
              </div>
            <h3 className="articlePrevTitle">
                {object.node.frontmatter.title}
              </h3>
              <br/>
              </Link>;
            })
          }
        </div>
      </div>
      <br/>
      <div
        className="social"
      >
        <h4 className='title'>
          SOCIAL
        </h4>
        <Social />
      </div>
        <div>
          <br/>
          <h4 className='title'>
            TAG
          </h4>
          <Tags/>
        </div>
        
      </div>
    </div>
    
  </Layout>
  )
}
export const query = graphql`
query($slug: String!) {
    article: allMarkdownRemark(sort: {fields: [frontmatter___date], order: DESC},
      filter: { frontmatter: {slug: {eq: $slug}}}) {
      totalCount
      edges {
          node {
            frontmatter {
              title
              date
              author
              slug
              tags {
                frontmatter{
                  name
                  label
                }
              }
              thumbnail
              banner
            }
            html
          }
    
      }
    }
    others: allMarkdownRemark(filter: {fileAbsolutePath: {regex: "/posts/"}}, sort: {fields: [frontmatter___date], order: DESC},limit: 4) {
      totalCount
      edges {
          node {
            frontmatter {
              title
              date
              author
              slug
              thumbnail
              banner
            }
            html
          }
    
      }
    }
  }
`